import classNames from 'classnames'
import React from 'react'

import { Box, type BoxProps } from '~/components/elements/Box'

import styles from './Stack.css'

export type StackProps = BoxProps & {
  align?: 'center' | 'end' | 'normal' | 'start'
  direction: 'column-reverse' | 'column' | 'row-reverse' | 'row'
  inline?: boolean
  justify?: 'center' | 'end' | 'normal' | 'space-between' | 'start'
  spacing: 0 | 1 | 2 | 4 | 8
  wrap?: boolean
}

export const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  (
    {
      align = 'normal',
      className,
      'data-testid': dataTestId = 'components-elements-stack',
      direction,
      inline = false,
      justify = 'normal',
      spacing,
      wrap = false,
      ...rest
    },
    ref,
  ) => (
    <Box
      ref={ref}
      className={classNames(
        styles.root,
        styles[`direction-${direction}`],
        styles[`align-${align}`],
        styles[`justify-${justify}`],
        {
          [styles.inline]: inline,
          [styles.wrap]: wrap,
          [styles[`spacing-${spacing}`]]: spacing !== 0,
        },
        className,
      )}
      data-testid={dataTestId}
      {...rest}
    />
  ),
)
